import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import moment from 'moment';
import toast from "react-hot-toast";

import { formatErrorMessage } from '../../utils/formatError';
import { CheckBeforeCreate, dataForCreate, dataForProjectRoutesCheckboxes, dataForCreateVacancyModal } from '../../utils/checkBeforeCreate';
import {
	actionUnloadReportsConsolidated,
	actionUnloadCustomerReportsData,
	actionUnloadReportsWithLinks,
	actionUnloadCustomerReports,
	actionUpdateDeliveryStatus,
	actionExportAverageFacing,
	actionUnloadReportsPhotos,
	actionUnloadClientReport,
	actionUnloadReportsList,
	actionUnloadHotline,
	actionShareOfShelf,
	actionCopyReports,
	actionCreateGeo,
	actionExportOsa,
	actionImportReportKPI
} from '../../redux/action/userReports/actionUserReports';
import {
	actionSetSingleReportSettings,
	actionClientRequestReport,
	actionCancelReportReview,
	actionDeleteReportPhotos,
	actionClientAcceptReport,
	actionCancelReportClaim,
	actionRevisionReport,
	actionApproveReport,
	actionRejectReport,
	actionDeleteReport,
	actionDeclineRate,
	actionAcceptRate,
	actionCopyReport,
} from '../../redux/action/userSingleReport/actionUserSingleReport';
import {
	actionUpdateVacancy,
	actionCreateVacancy,
	actionVacanciesExport,
	actionRemoveSelections
} from '../../redux/action/recruiting/actionVacancy';
import { actionCreateApplication } from '../../redux/action/recruiting/actionApplicationForm';
// eslint-disable-next-line
import { reducerSingleApplicationErrors } from '../../redux/reducer/recruiting/reducers/reducerSingleApplication';
import {
	actionCreateExpiredReports,
	actionDeleteExpiredReports,
	actionExportExpiredReports,
} from '../../redux/action/userReports/actionExpiredReports';
import { reducerGetVacantRoutes, reducerClearInputValuesNoModal } from '../../redux/reducer/projects/reducers/reduserVacantRoutesListNoModal';
import {
	reducerSelectedUpdateStatus,
	reducerAdminReportsSettings,
	reducerSelectedReports,
	reducerReportsSettings,
	reducerReportsStatus,
	reducerHeaderBtn,
} from '../../redux/reducer/userReports/reducers/userReports';
import {
	reducerSelectedAdminReportSettings,
	reducerSingleReportSettingsOptions,
	reducerSelectedReportSettings,
	reducerDeletePhotosId,
} from '../../redux/reducer/userSingleReport/reducers/userSingleReport';
import {
	reducerHandleErrors,
	reducerCreateVacancyInputValues
} from '../../redux/reducer/recruiting/reducers/reducerCreateVacancy';
import {
	reducerVacancyListSettings,
	reducerVacancyStatus,
	reducerVacancyStatusMessage
} from '../../redux/reducer/recruiting/reducers/reducerVacancy';
import {
	reducerRoutesSettings,
	reducerRoutesStatus
} from '../../redux/reducer/projects/reducers/reducerRoutesList';
import {
	reducerSetPending,
	reducerVacantRoutesSettings,
	reducerVacantRoutesStatus,
	reducerUpdatedData,
	reducerVacantRoutesInputValues
} from '../../redux/reducer/projects/reducers/reducerVacantRoutesList';
import {
	reducerSingleVacancyIV,
	reducerGetSingleVacancy,
	reducerSingleVacancyStatus,
	reducerSingleVacancyStatusMessage,
} from '../../redux/reducer/recruiting/reducers/reducerSingleVacancy';
import { reducerVisitScheduleHistory } from '../../redux/reducer/userSingleReport/reducers/visitSchedule';
import { reducerExpiredReportsSettings } from '../../redux/reducer/userReports/reducers/expiredReports';
import { actionUnloadScheduleInExcel } from '../../redux/action/userSingleReport/actionVisitSchedule';
import { actionUnloadIntegrationErrors, actionImportReport } from '../../redux/action/easymerch/actionIntegrationErrors';
import { actionSendRoutesToEasyMerch } from '../../redux/action/easymerch/actionUsers';
import { actionUnloadOutlets } from '../../redux/action/easymerch/actionOutlets';
import { actionImportPos } from '../../redux/action/tunder/actionRetailOutlets';
import { AppDispatch } from '../../redux/reducer/store';
import AdminSingleReportSettingsSection from './sections/adminSingleReportSettingsSection';
import CustomerReportsSettingsSection from './sections/customerReportsSettingsSection';
import ExpiredReportsSettingsSection from './sections/expiredReportsSettingsSection';
import UpdateDeliveryStatusSection from './sections/updateDeliveryStatusSections';
import VacantRoutesSettingsSection from './sections/vacantRoutesSettingsSection';
import AdminReportsSettingsSection from './sections/adminReportsSettingsSection';
import SingleReportSettingsSection from './sections/singleReportSettingsSection';
import ScheduleAddressInfoSection from './sections/scheduleAddressInfoSection';
import VacancyListSettingsSection from './sections/vacancyListSettingsSection';
import UnloadReportsPhotoSection from './sections/unloadReportsPhotoSection';
import UpdateReviewStatusSection from './sections/updateReviewStatusSection';
import AddRouteOnVacancySection from './sections/addRouteonVacancySection';
import VacancyCreateNewSection from './sections/vacancyNewCreateSection';
import UpdateRateStatusSection from './sections/updateRateStatusSection';
import OutletsDownloadSection from './sections/outletsDownloadSection';
import RoutesSettingsSection from './sections/routesSettingsSection';
import VacancyUpdateSection from './sections/vacancyUpdateSection';
import DeletePhotosSection from './sections/deletePhotosSection';
import DeleteReportSection from './sections/deleteReportSection';
import LostVacancyRoutestSection from './sections/lostVacancyRoutestSection';
import DeleteRouteSection from './sections/deleteRouteSection';
import ReportCheckSection from './sections/reportCheckSection';
import NewApplication from './sections/newApplicationSection';
import NewUsersClaims from './sections/newEmployeesSection';
import NavigateToSection from './sections/navigateToSection';
import CopyReportSection from './sections/copyReportSection';
import CreateGeoSection from './sections/createGeoSection';
import CreateVacancy from './sections/createVacancy';
import LimitSection from './sections/limitSection';
import Blackout from '../custom/blackout/blackout';
import ToastPopup from "../custom/toastPopup/toastPopup";
import { generateStyles } from "../../utils/generateToastStyles";

import Close from '../../assets/icons/close.svg';
import styles from './headerBtn.module.scss';

interface IHeaderBtnProps {
	modalTitle: string;
	content: string;
	purpose: string;
}

const unloadActions: any = {
	unloadReportsConsolidated: actionUnloadReportsConsolidated,
	unloadCustomerReportsData: actionUnloadCustomerReportsData,
	unloadReportsWithLinks: actionUnloadReportsWithLinks,
	unloadCustomerReports: actionUnloadCustomerReports,
	unloadReportsPhotos: actionUnloadReportsPhotos,
	unloadExpiredList: actionExportExpiredReports,
	unloadClientReport: actionUnloadClientReport,
	unloadReportsList: actionUnloadReportsList,
	averageFacing: actionExportAverageFacing,
	unloadHotline: actionUnloadHotline,
	shelfShare: actionShareOfShelf,
	osa: actionExportOsa,
};

const copyActions: any = {
	copyReport: actionCopyReport,
	copyReports: actionCopyReports,
};

const HeaderBtn: FC<IHeaderBtnProps> = ({ content, purpose, modalTitle }) => {
	const dispatch: any = useDispatch<AppDispatch>();
	const navigate = useNavigate();

	const {
		adminReportsSettings,
		reportsInputValues,
		selectedReportsId,
		actualModalTitle,
		reportsSettings,
		actualPurpose,
		reports,
	} = useSelector((state: any) => state.userReports.userReports);
	const { selectedUsers } = useSelector((state: any) => state.easymerch.users);
	const { data } = useSelector((state: any) => state.user.user);
	const { report, photos, settings, adminSettings } = useSelector(
		(state: any) => state.userSingleReport.userSingleReport
	);
	const { limit, offset, outletsInputValues } = useSelector(
		(state: any) => state.easymerch.outlets
	);
	const { reportsId, expiredReportsSettings } = useSelector(
		(state: any) => state.userReports.expiredReports
	);
	const { isOpenHistory } = useSelector(
		(state: any) => state.userSingleReport.visitSchedule
	);
	const { vacancyCreateInputValues } = useSelector(
		(state: any) => state.recruiting.createVacancy
	);
	const { data: singleVacancyData, inputValues, editForm } = useSelector(
		(state: any) => state.recruiting.singleVacancy
	);

	// eslint-disable-next-line
	const { routesSettings, vacantCBnew } = useSelector(
		(state: any) => state.projects.routes
	);

	const {
		vacantRoutesSettings,
		vacantCheckboxes,
		vacantCheckboxesList,
	} = useSelector(
		(state: any) => state.projects.vacantRoutes
	);

	const { vacantCheckboxesNoModule, } = useSelector(
		(state: any) => state.projects.vacantRoutesNoModal
	);

	const { selectedUserId } = useSelector((state: any) => state.roles.usersList);

	const { applicationCreateIV } = useSelector(
		(state: any) => state.recruiting.applicationCreate
	);

	const { selectedVacancy, applicationData, vacancyListSettings, selectedVacanciesId } = useSelector(
		(state: any) => state.recruiting.vacancyList
	);

	const { data: application, applicationInputValues } = useSelector((state: any) => state.recruiting.singleApplication)

	const [selectedActionOption, setSelectedActionOption] =
		useState<string>('acceptReport');
	const [selectedCheckTypeOption, setSelectedCheckTypeOption] =
		useState<string>('DISTANCE');
	const [selectedDeliveryOption, setSelectedDeliveryOption] =
		useState<string>('OnTime');
	const [selectedRateStatusOption, setSelectedRateStatusOption] =
		useState<string>('NotChecked');
	const [selectedReviewStatusOption, setSelectedReviewStatusOption] =
		useState<string>('NotChecked');
	const [selectedReviewReasonId, setSelectedReviewReasonId] =
		useState<any>(null);
	const [reportCheckCommentValue, setReportCheckCommentValue] =
		useState<string>('');
	const [selectedReportCheckReasons, setSelectedReportCheckReasons] = useState<
		any[]
	>([]);
	const [selectedReportsSettings, setSelectedReportsSettings] = useState<any>(
		data?.isCustomer ? reportsSettings : adminReportsSettings
	);
	const [selectedExpiredReportsSettings, setSelectedExpiredReportsSettings] =
		useState<any>(expiredReportsSettings);

	const [selectedRoutesSettings, setSelectedRoutesSettings] =
		useState<any>(routesSettings);

	const [selectedVacantRoutesSettings, setSelectedVacantRoutesSettings] =
		useState<any>(vacantRoutesSettings);

		const [selectedVacancyListSettings, setSelectedVacancyListSettings] =
		useState<any>(vacancyListSettings);

	const [isCheckedFullInfo, setIsCheckedFullInfo] = useState<boolean>(
		(data?.isCustomer
			? JSON.parse(localStorage.getItem('isSelectedAllTabs') as string)
			: JSON.parse(localStorage.getItem('isSelectedAllAdminTabs') as string)) ||
		false
	);
	const [isCheckedAllSettings, setIsCheckedAllSettings] = useState<boolean>(
		(data?.isCustomer
			? JSON.parse(localStorage.getItem('isSelectedAllSettings') as string)
			: JSON.parse(
				localStorage.getItem('isSelectedAllAdminSettings') as string
			)) || false
	);
	const [isCheckedAllExpiredSettings, setIsCheckedAllExpiredSettings] =
		useState<boolean>(
			JSON.parse(
				localStorage.getItem('isSelectedAllExpiredSettings') as string
			) || false
		);


	const [isCheckedAllRoutesSettings, setIsCheckedAllRoutesSettings] =
		useState<boolean>(
			JSON.parse(
				localStorage.getItem('isSelectedAllRoutesSettings') as string
			) || false
		);

	const [isCheckedAllVacantRoutesSettings, setIsCheckedAllVacantRoutesSettings] =
		useState<boolean>(
			JSON.parse(
				localStorage.getItem('isSelectedAllVacantRoutesSettings') as string
			) || false
		);

	const [isCheckedAllVacancyListSettings, setIsCheckedAllVacancyListSettings] =
		useState<boolean>(
			JSON.parse(
				localStorage.getItem('isSelectedAllVacancyListSettings') as string
			) || false
		);

	const [selectedReportTabs, setSelectedReportTabs] = useState<any>(
		data?.isCustomer ? settings : adminSettings
	);
	const [selectedCustomServices, setSelectedCustomServices] = useState<any>([]);
	const [reorderedReportOptions, setReorderedReportOptions] = useState<any>([]);
	const [reviewReasonError, setReviewReasonError] = useState<string>('');
	const [reportCheckError, setReportCheckError] = useState<string>('');
	const [selectedActions, setSelectedActions] = useState<any>([]);
	const [selectedFiles, setSelectedFiles] = useState<any>([]);
	const [reportLimit, setReportLimit] = useState<string>('');
	const [selectedDate, setSelectedDate] = useState(null);
	const [open, setOpen] = useState<boolean>(false);
	const [error, setError] = useState<string>('');
	const [disabledButton, setDisabledButton] = useState<boolean>(false);

	const arrType = ['ON_ROUTE', 'PARTIAL_ROUTE']

	const settingsActions: any = {
		singleReportSettings: {
			reducer: reducerSelectedReportSettings,
			selectedTabsKey: 'selectedTabs',
			selectedTabs: selectedReportTabs,
			allTabsKey: 'isSelectedAllTabs',
			allTabs: isCheckedFullInfo,
			reorderAction: () => {
				dispatch(
					actionSetSingleReportSettings(
						'customerReport',
						reorderedReportOptions
					)
				);
				dispatch(
					reducerSingleReportSettingsOptions({ entity: reorderedReportOptions })
				);
			},
		},
		adminSingleReportSettings: {
			reducer: reducerSelectedAdminReportSettings,
			selectedTabsKey: 'selectedTabs',
			selectedTabs: selectedReportTabs,
			allTabsKey: 'isSelectedAllAdminTabs',
			allTabs: isCheckedFullInfo,
			reorderAction: () => {
				dispatch(
					actionSetSingleReportSettings('adminReport', reorderedReportOptions)
				);
				dispatch(
					reducerSingleReportSettingsOptions({ entity: reorderedReportOptions })
				);
			},
		},
		customerReportsSettings: {
			reducer: reducerReportsSettings,
			selectedTabsKey: 'selectedReportsTabs',
			selectedTabs: selectedReportsSettings,
			allTabsKey: 'isSelectedAllSettings',
			allTabs: isCheckedAllSettings,
		},
		adminReportsSettings: {
			reducer: reducerAdminReportsSettings,
			selectedTabsKey: 'selectedAdminReportsTabs',
			selectedTabs: selectedReportsSettings,
			allTabsKey: 'isSelectedAllAdminSettings',
			allTabs: isCheckedAllSettings,
		},
		expiredReportsSettings: {
			reducer: reducerExpiredReportsSettings,
			selectedTabsKey: 'selectedExpiredReportsTabs',
			selectedTabs: selectedExpiredReportsSettings,
			allTabsKey: 'isSelectedAllExpiredSettings',
			allTabs: isCheckedAllExpiredSettings,
		},
		routesSettings: {
			reducer: reducerRoutesSettings,
			selectedTabsKey: 'selectedRoutesTabs',
			selectedTabs: selectedRoutesSettings,
			allTabsKey: 'isSelectedAllRoutesSettings',
			allTabs: isCheckedAllRoutesSettings,
		},
		vacantRoutesSettings: {
			reducer: reducerVacantRoutesSettings,
			selectedTabsKey: 'selectedVacantRoutesTabs',
			selectedTabs: selectedVacantRoutesSettings,
			allTabsKey: 'isSelectedAllVacantRoutesSettings',
			allTabs: isCheckedAllVacantRoutesSettings,
		},
		vacancyListSettings: {
			reducer: reducerVacancyListSettings,
			selectedTabsKey: 'selectedVacancyListTabs',
			selectedTabs: selectedVacancyListSettings,
			allTabsKey: 'isSelectedAllVacancyListSettings',
			allTabs: isCheckedAllVacancyListSettings,
		},
	};

	const closeActions: any = {
		reportCheck: () => {
			setSelectedActionOption('acceptReport');
			setSelectedCheckTypeOption('DISTANCE');
			setSelectedReportCheckReasons([]);
			setReportCheckCommentValue('');
		},
		updateDeliveryStatus: () => {
			setSelectedDeliveryOption('OnTime');
		},
		updateRateStatus: () => {
			setSelectedRateStatusOption('NotChecked');
		},
		updateReviewStatus: () => {
			setSelectedReviewStatusOption('NotChecked');
			setSelectedReviewReasonId(null);
			setReviewReasonError('');
		},
		customerReportsSettings: () => {
			setSelectedReportsSettings(reportsSettings);
			setIsCheckedAllSettings(
				JSON.parse(localStorage.getItem('isSelectedAllSettings') as string) ||
				false
			);
		},
		adminReportsSettings: () => {
			setSelectedReportsSettings(adminReportsSettings);
			setIsCheckedAllSettings(
				JSON.parse(
					localStorage.getItem('isSelectedAllAdminSettings') as string
				) || false
			);
		},
		expiredReportsSettings: () => {
			setSelectedExpiredReportsSettings(expiredReportsSettings);
			setIsCheckedAllExpiredSettings(
				JSON.parse(
					localStorage.getItem('isSelectedAllExpiredSettings') as string
				) || false
			);
		},
		RoutesSettings: () => {
			setSelectedRoutesSettings(routesSettings);
			setIsCheckedAllRoutesSettings(
				JSON.parse(
					localStorage.getItem('isSelectedAllRoutesSettings') as string
				) || false
			);
		},
		VacantRoutesSettings: () => {
			setSelectedVacantRoutesSettings(vacantRoutesSettings);
			setIsCheckedAllVacantRoutesSettings(
				JSON.parse(
					localStorage.getItem('isSelectedAllVacantRoutesSettings') as string
				) || false
			);
		},
		VacancyListSettings: () => {
			setSelectedVacancyListSettings(vacancyListSettings);
			setIsCheckedAllVacancyListSettings(
				JSON.parse(
					localStorage.getItem('isSelectedAllVacancyListSettings') as string
				) || false
			);
		},
		singleReportSettings: () => {
			setSelectedReportTabs(settings);
			setIsCheckedFullInfo(
				JSON.parse(localStorage.getItem('isSelectedAllTabs') as string) || false
			);
		},
		adminSingleReportSettings: () => {
			setSelectedReportTabs(adminSettings);
			setIsCheckedFullInfo(
				JSON.parse(localStorage.getItem('isSelectedAllAdminTabs') as string) ||
				false
			);
		},
	};

	const handleClickApplyBtn = (e: any) => {
		console.log(actualPurpose);
		if (actualPurpose === 'navigateToVacancyList') {
			const urlParams = new URLSearchParams(window.location.search);
			const source = urlParams.get('source');
			inputValues.type && navigate(source || '/recruiting/vacancy');
		}

		if (actualPurpose === 'navigateToProjectsList') {
			navigate(`/projects`);
		}

		if (actualPurpose === 'navigateToApplicationsList') {
			navigate(`/recruiting/applicationform`);
		}

		if (actualPurpose === 'saveApplication') {
			let errors = []
			if (!applicationInputValues.applicantStatus) {
				errors.push('status')
			}
			if (!applicationInputValues.firstName) {
				errors.push('firstName')
			}
			if (!applicationInputValues.lastName) {
				errors.push('lastName')
			}
			if (!applicationInputValues.gender) {
				errors.push('gender')
			}
			if (errors.length === 0) {
				const obj = { application: application.application, ...applicationInputValues }
				dispatch(actionCreateApplication(obj))
			} else {
				dispatch(reducerSingleApplicationErrors(errors))
			}
		}

		if (actualPurpose === 'addRouteOnVacancy') {
			dispatch(reducerSetPending(true));
				const updateRoutes = inputValues?.routes?.length ? vacantCheckboxesList.map((obj1: any) => {
				const obj2 = inputValues.routes.find((elem: any) => elem.project.id === obj1.project.id);
				if (obj2) {
					const updatedRoutes = obj2.routes.concat(obj1.routeNo);
					return { ...obj2, routes: updatedRoutes };
				} else {
					return { project: obj1.project, routes: [obj1.routeNo] };
				}
			}) : [];

			const newRoutes = inputValues.routes ? inputValues?.routes.concat(updateRoutes) : dataForProjectRoutesCheckboxes(vacantCheckboxesList);
			const newProjects = inputValues.projects.concat(vacantCheckboxesList.map((el: any)=>  el.project));
			dispatch(actionUpdateVacancy({ ...inputValues, routes: newRoutes, projects: newProjects }))
				.then((res: any) => {
					if (res.status === 200) {
						dispatch(reducerGetVacantRoutes({data: []}));
						dispatch(reducerSingleVacancyStatus(res.status));
						dispatch(reducerSingleVacancyStatusMessage('Маршрут успешно добавлен'));
						dispatch(reducerSetPending(false));
						dispatch(reducerVacantRoutesInputValues({ project: null }))
					} else if (res?.response?.status === 400) {
						dispatch(reducerSingleVacancyStatus(res?.response?.status));
						dispatch(
							reducerSingleVacancyStatusMessage(
								formatErrorMessage(res?.response?.data)
							)
						);
					} else {
					}
				})
				.then(() => {
				});
		}
		if (actualPurpose === 'removeSelections') {
			const vacancyId = inputValues?.vacancy?.id;
			dispatch(actionRemoveSelections(vacancyId));
		}

		if (actualPurpose === 'deleteRoute') {
			const noCheckedItems = vacantCheckboxesNoModule && vacantCheckboxesNoModule.filter((item: any) => !item.checked);
			const CheckedItems = vacantCheckboxesNoModule && vacantCheckboxesNoModule.filter((item: any) => item.checked);
			if (!CheckedItems || !CheckedItems.length) {
				toast(
					(t) => (
						<ToastPopup
							title="Не выбран ни один маршрут"
							isSuccess={false}
							toast={toast}
							t={t}
						/>
					),
					generateStyles(false)
				);
			} else {
				const updatedInputValues = { ...inputValues };
				if (!noCheckedItems.length) {
					updatedInputValues.type = 'LOST_ROUTE';
					delete updatedInputValues.routes;
				} else {
					const projectRoutes = dataForCreateVacancyModal(noCheckedItems, inputValues.projects);
					const newRoutes = projectRoutes.filter((el: any) => el.routes.length > 0);
					updatedInputValues.routes = newRoutes;
					updatedInputValues.projects = newRoutes.map((el: any) => el.project);
				}
				dispatch(actionUpdateVacancy(updatedInputValues))
					.then((res: any) => {
						dispatch(reducerGetVacantRoutes({data: []}));
						dispatch(reducerClearInputValuesNoModal());
						dispatch(reducerGetSingleVacancy(res.data))
						toast(
							(t) => (
								<ToastPopup
									title="Маршрут успешно удален"
									isSuccess={true}
									toast={toast}
									t={t}
								/>
							),
							generateStyles(true)
						);
					})
			}
		}

		if (actualPurpose === 'createVacancyVacantRoutes') {
			if ((!arrType.includes(vacancyCreateInputValues.type) && vacancyCreateInputValues.projects) || (arrType.includes(vacancyCreateInputValues.type) && vacancyCreateInputValues.routesNo)) {
				setDisabledButton(true);
				dispatch(actionCreateVacancy(vacancyCreateInputValues, '4', navigate)).then(() => {
					setDisabledButton(false);
				});
			} else {
				const errors = [];
				if (!vacancyCreateInputValues.type) {
					errors.push('errorType');
				}
				if (!vacancyCreateInputValues.projects) {
					errors.push('errorProject');
					dispatch(reducerVacantRoutesStatus(2));
				}
				if (vacancyCreateInputValues.projects && arrType.includes(vacancyCreateInputValues.type) && !vacancyCreateInputValues.routesNo) {
					errors.push('errorRoutesNo');
					dispatch(reducerVacantRoutesStatus(3));
				}
				dispatch(reducerHandleErrors(errors));
				return console.log('errors');
			}
		}
		if (actualPurpose === 'createVacancyVacant') {
			if ((!arrType.includes(vacancyCreateInputValues.type) && vacancyCreateInputValues.projects) || (arrType.includes(vacancyCreateInputValues.type) && vacancyCreateInputValues.routesNo)) {
				setDisabledButton(true);
				console.log(vacancyCreateInputValues);
				dispatch(actionCreateVacancy(vacancyCreateInputValues, '1', navigate))
					.then(() => {
						handleClickCloseBtn();
						setDisabledButton(false);
					});
			} else {
				const errors = [];
				if (!vacancyCreateInputValues.type) {
					errors.push('errorType');
				}
				if (!vacancyCreateInputValues.projects) {
					errors.push('errorProject');
					dispatch(reducerVacancyStatus(2));
				}
				if (vacancyCreateInputValues.projects && arrType.includes(vacancyCreateInputValues.type) && !vacancyCreateInputValues.routesNo) {
					errors.push('errorRoutesNo');
					dispatch(reducerVacancyStatus(3));
				}
				dispatch(reducerHandleErrors(errors));
				return console.log('errors');
			}
		}

		if (actualPurpose === 'createVacancyRoutes') {
			if ((!arrType.includes(vacancyCreateInputValues.type) && vacancyCreateInputValues.projects) || (arrType.includes(vacancyCreateInputValues.type) && vacancyCreateInputValues.routesNo)) {
				setDisabledButton(true);
				dispatch(actionCreateVacancy(vacancyCreateInputValues, '2', navigate))
					.then(() => {
						handleClickCloseBtn();
						setDisabledButton(false);
					});
			} else {
				const errors: any = [];
				if (!vacancyCreateInputValues.type) {
					errors.push('errorType');
				}
				if (!vacancyCreateInputValues.projects) {
					errors.push('errorProject');
					dispatch(reducerRoutesStatus(2));
				}
				if (vacancyCreateInputValues.projects && arrType.includes(vacancyCreateInputValues.type) && !vacancyCreateInputValues.routesNo) {
					errors.push('errorRoutesNo');
					dispatch(reducerRoutesStatus(3));
				}
				dispatch(reducerHandleErrors(errors));
				return console.log('errors');
			}
		}

		if (actualPurpose === 'outletsDownload') {
			selectedFiles.length &&
				dispatch(actionImportPos(selectedFiles)).then(() => {
					setSelectedFiles([]);
				});
		}

		if (actualPurpose === 'UnloadData') {
			if(selectedVacanciesId.length > 0) {
				const arrayId = selectedVacanciesId.map((item: any) => item.id)
				dispatch(actionVacanciesExport(arrayId, data?.email));
			} else {
				dispatch(reducerVacancyStatus(400));
				dispatch(reducerVacancyStatusMessage('Не выбрана ни одна вакансия'))
			}
		}

		if (settingsActions.hasOwnProperty(actualPurpose)) {
			const {
				selectedTabsKey,
				reorderAction,
				selectedTabs,
				allTabsKey,
				reducer,
				allTabs,
			} = settingsActions[actualPurpose];

			localStorage.setItem(allTabsKey, JSON.stringify(allTabs ? true : false));
			localStorage.setItem(selectedTabsKey, JSON.stringify(selectedTabs));

			reorderAction && reorderAction();
			dispatch(reducer(selectedTabs));
		}

		if (actualPurpose === 'errorsUnload') {
			dispatch(actionUnloadIntegrationErrors(0));
		}

		if (actualPurpose === 'outletsUnload') {
			dispatch(actionUnloadOutlets(limit, offset, outletsInputValues));
		}

		if (copyActions.hasOwnProperty(actualPurpose)) {
			const action = copyActions[actualPurpose];

			dispatch(
				action({
					reports:
						actualPurpose === 'copyReport'
							? [
								{
									id: report && report.reportId.id,
								},
							]
							: selectedReportsId,
					date: !selectedDate
						? moment(new Date()).format('YYYY-MM-DD')
						: moment(selectedDate).format('YYYY-MM-DD'),
				})
			);
		}

		if (actualPurpose === 'updateDeliveryStatus') {
			dispatch(
				actionUpdateDeliveryStatus({
					reports: selectedReportsId.map((report: any) => {
						return {
							id: report.id,
							name: '',
						};
					}),
					deliveryStatus: selectedDeliveryOption,
				})
			);
			dispatch(reducerSelectedUpdateStatus(selectedDeliveryOption));
			setSelectedDeliveryOption('OnTime');
		}

		if (actualPurpose === 'deletePhotos') {
			if (photos && photos.length) {
				dispatch(
					actionDeleteReportPhotos({
						reportId: report && report.reportId.id,
						medias: [
							photos.map((photoId: number) => {
								return {
									id: photoId,
								};
							}),
						],
					})
				);
				dispatch(reducerDeletePhotosId([]));
			}
		}

		if (actualPurpose === 'deleteExpired') {
			dispatch(actionDeleteExpiredReports(reportsId));
		}

		if (actualPurpose === 'deleteReport') {
			dispatch(actionDeleteReport(report && report.reportId.id)).then(() => {
				navigate('/reports');
			});
		}

		if (actualPurpose === 'applicationCreate') {
			dispatch(actionCreateApplication(applicationCreateIV)).then(() => {
				navigate('/recruiting/applicationform');
			});
		}

		if (actualPurpose === 'vacancyUpdate') {
			if (!inputValues.name) {
				dispatch(reducerSingleVacancyStatus(400));
				dispatch(reducerSingleVacancyStatusMessage('Заполните поле название вакансии'));
			} else {
				const newValues = { ...inputValues };
				delete newValues.projectRoutes;
				dispatch(actionUpdateVacancy(newValues))
					.then((res: any) => {
						if (res.status === 200) {
							dispatch(reducerSingleVacancyStatus(res.status));
							dispatch(reducerSingleVacancyStatusMessage('Вакансия успешно обновлена'));
							dispatch(reducerSetPending(false));
						} else if (res?.response?.status === 400) {
							dispatch(reducerSingleVacancyStatus(res?.response?.status));
							dispatch(
								reducerSingleVacancyStatusMessage(
									formatErrorMessage(res?.response?.data)
								)
							);
						} else {
						}
					})
			}
		}
		if (actualPurpose === 'createVacancy') {
			if (vacancyCreateInputValues.type && vacancyCreateInputValues.project) {
				dispatch(actionCreateVacancy({ ...vacancyCreateInputValues }, '3'))
			} else {
				const errors = [];
				if (!vacancyCreateInputValues.type) {
					errors.push('errorType');
				}
				if (!vacancyCreateInputValues.project) {
					errors.push('errorProject');
				}
				dispatch(reducerHandleErrors(errors));
			}
		}
		if (actualPurpose === 'newApplication') {
			let obj = {};
			if (application.application) {
				obj = {
					// @ts-ignore
					application: application.application,
				};
			}
			if (selectedVacancy?.vacancy?.id) {
				obj = {
					...obj,
					// @ts-ignore
					vacancy: {
						id: selectedVacancy?.vacancy?.id,
					},
				};
			}
			obj = {
				...obj,
				applicantStatus: 'NEW',
				gender: 'Male',
				...applicationData,
			};
			dispatch(actionCreateApplication(obj)).then((res: any) => {
				navigate(`/recruiting/applicationform/${res.data.application.id}`);
				window.location.reload()
			});
		}

		if (actualPurpose === 'createGeo') {
			if (!!selectedReportsId.length) {
				selectedReportsId.forEach((reportId: any, index: any) => {
					const isLastRequest = index === selectedReportsId.length - 1;

					try {
						dispatch(actionCreateGeo(reportId.id)).then(() => {
							if (isLastRequest) {
								dispatch(
									reducerReportsStatus({
										reportsStatus: 200,
										reportsRequestPurpose: 'createGeo',
									})
								);
							}
						});
					} catch (err) {
						dispatch(
							reducerReportsStatus({
								reportsStatus: 0,
								reportsRequestPurpose: 'createGeo',
							})
						);
					}
				});
			}
		}

		if (actualPurpose === 'updateRateStatus') {
			if (
				!!selectedReportsId.length &&
				selectedRateStatusOption === 'NotChecked'
			) {
				const filteredSelectedReports = selectedReportsId.filter(
					(elem: any) =>
						reports.find((report: any) => report.reportId === elem.id)
							.rateStatus !== 'NotChecked'
				);

				if (!!filteredSelectedReports.length) {
					filteredSelectedReports.forEach((reportId: any, index: any) => {
						const isLastRequest = index === filteredSelectedReports.length - 1;

						dispatch(
							actionCancelReportClaim({
								reportId: {
									id: reportId.id,
									name: '',
								},
							})
						).then(() => {
							if (isLastRequest) {
								dispatch(
									reducerReportsStatus({
										reportsStatus: 200,
										reportsRequestPurpose: 'updateRateStatus',
									})
								);
							}
						});
					});
				} else {
					dispatch(
						reducerReportsStatus({
							reportsStatus: 0,
							reportsRequestPurpose: 'updateRateStatus',
						})
					);
					dispatch(reducerSelectedReports([]));
				}
			} else if (
				!!selectedReportsId.length &&
				selectedRateStatusOption === 'Accepted'
			) {
				const filteredSelectedReports = selectedReportsId.filter(
					(elem: any) =>
						reports.find((report: any) => report.reportId === elem.id)
							.rateStatus !== 'Accepted'
				);

				if (!!filteredSelectedReports.length) {
					filteredSelectedReports.forEach((reportId: any, index: any) => {
						const isLastRequest = index === filteredSelectedReports.length - 1;

						dispatch(
							actionClientAcceptReport({
								reportId: {
									id: reportId.id,
									name: '',
								},
								rateNote: '',
								weigth: 0,
							})
						).then(() => {
							if (isLastRequest) {
								dispatch(
									reducerReportsStatus({
										reportsStatus: 200,
										reportsRequestPurpose: 'updateRateStatus',
									})
								);
							}
						});
					});
				} else {
					dispatch(
						reducerReportsStatus({
							reportsStatus: 0,
							reportsRequestPurpose: 'updateRateStatus',
						})
					);
					dispatch(reducerSelectedReports([]));
				}
			} else if (
				!!selectedReportsId.length &&
				selectedRateStatusOption === 'Declined'
			) {
				const filteredSelectedReports = selectedReportsId.filter(
					(elem: any) => {
						const actualReport = reports.find(
							(report: any) => report.reportId === elem.id
						).rateStatus;

						return (
							actualReport !== 'Declined' &&
							actualReport !== 'PartiallyDeclined'
						);
					}
				);

				if (!!filteredSelectedReports.length) {
					filteredSelectedReports.forEach((reportId: any, index: number) => {
						const isLastRequest = index === filteredSelectedReports.length - 1;

						dispatch(
							actionDeclineRate({
								reportId: {
									id: reportId.id,
									name: '',
								},
								rateNote: '',
								weigth: 0,
							})
						).then(() => {
							if (isLastRequest) {
								dispatch(
									reducerReportsStatus({
										reportsStatus: 200,
										reportsRequestPurpose: 'updateRateStatus',
									})
								);
							}
						});
					});
				} else {
					dispatch(
						reducerReportsStatus({
							reportsStatus: 0,
							reportsRequestPurpose: 'updateRateStatus',
						})
					);
					dispatch(reducerSelectedReports([]));
				}
			}

			dispatch(reducerSelectedUpdateStatus(selectedRateStatusOption));
			setSelectedRateStatusOption('NotChecked');
		}

		if (actualPurpose === 'updateReviewStatus') {
			if (
				!!selectedReportsId.length &&
				selectedReviewStatusOption === 'NotChecked'
			) {
				const filteredSelectedReports = selectedReportsId.filter(
					(elem: any) =>
						reports.find((report: any) => report.reportId === elem.id)
							.reviewStatus !== 'NotChecked'
				);

				if (!!filteredSelectedReports.length) {
					filteredSelectedReports.forEach((reportId: any, index: any) => {
						const isLastRequest = index === filteredSelectedReports.length - 1;

						dispatch(actionCancelReportReview(reportId.id)).then(() => {
							if (isLastRequest) {
								dispatch(
									reducerReportsStatus({
										reportsStatus: 200,
										reportsRequestPurpose: 'updateReviewStatus',
									})
								);
							}
						});
					});
				} else {
					dispatch(
						reducerReportsStatus({
							reportsStatus: 0,
							reportsRequestPurpose: 'updateReviewStatus',
						})
					);
					dispatch(reducerSelectedReports([]));
				}
			} else if (
				!!selectedReportsId.length &&
				selectedReviewStatusOption === 'Approved'
			) {
				selectedReportsId.forEach((reportId: any, index: number) => {
					const isLastRequest = index === selectedReportsId.length - 1;

					dispatch(
						actionApproveReport({
							reportId: {
								id: reportId.id,
								name: '',
							},
							reviewComment: '',
							comment: '',
						})
					).then(() => {
						if (isLastRequest) {
							dispatch(
								reducerReportsStatus({
									reportsStatus: 200,
									reportsRequestPurpose: 'updateReviewStatus',
								})
							);
						}
					});
				});
			} else if (
				!!selectedReportsId.length &&
				selectedReviewStatusOption === 'Rejected'
			) {
				if (!selectedReviewReasonId) {
					setReviewReasonError('Нужно указать причину прежде, чем продолжить');
					return;
				} else {
					selectedReportsId.forEach((reportId: any, index: any) => {
						const isLastRequest = index === selectedReportsId.length - 1;

						dispatch(
							actionRejectReport({
								reportId: {
									id: reportId.id,
									name: '',
								},
								reviewReasonId: {
									id: selectedReviewReasonId,
								},
								reviewComment: '',
								comment: '',
							})
						).then(() => {
							if (isLastRequest) {
								dispatch(
									reducerReportsStatus({
										reportsStatus: 200,
										reportsRequestPurpose: 'updateReviewStatus',
									})
								);
							}
						});
					});
				}
			} else if (
				!!selectedReportsId.length &&
				selectedReviewStatusOption === 'Revision'
			) {
				if (!selectedReviewReasonId) {
					setReviewReasonError('Нужно указать причину прежде, чем продолжить');
					return;
				} else {
					const filteredSelectedReports = selectedReportsId.filter(
						(elem: any) =>
							reports.find((report: any) => report.reportId === elem.id)
								.reviewStatus !== 'Revision'
					);

					if (!!filteredSelectedReports.length) {
						filteredSelectedReports.forEach((reportId: any, index: number) => {
							const isLastRequest =
								index === filteredSelectedReports.length - 1;

							dispatch(
								actionRevisionReport({
									reportId: {
										id: reportId.id,
										name: '',
									},
									reviewReasonId: {
										id: selectedReviewReasonId,
									},
									reviewComment: '',
									comment: '',
									customReason: '',
								})
							).then(() => {
								if (isLastRequest) {
									dispatch(
										reducerReportsStatus({
											reportsStatus: 200,
											reportsRequestPurpose: 'updateReviewStatus',
										})
									);
								}
							});
						});
					} else {
						dispatch(
							reducerReportsStatus({
								reportsStatus: 0,
								reportsRequestPurpose: 'updateReviewStatus',
							})
						);
						dispatch(reducerSelectedReports([]));
					}
				}
			}

			dispatch(reducerSelectedUpdateStatus(selectedReviewStatusOption));
			setSelectedReviewStatusOption('NotChecked');
			setSelectedReviewReasonId(null);
		}

		if (actualPurpose === 'reportCheck') {
			if (selectedActionOption === 'acceptReport') {
				dispatch(
					actionAcceptRate(
						{
							reportId: {
								id: report && report?.reportId.id,
							},
							reviewReasons: selectedReportCheckReasons.map((value: any) => {
								return {
									id: parseFloat(value),
								};
							}),
							notes: reportCheckCommentValue,
							checkType: selectedCheckTypeOption,
						},
						'reportCheckBtn'
					)
				);
			} else if (
				selectedActionOption === 'formClaim' ||
				selectedActionOption === 'formRecommendation'
			) {
				if (reportCheckCommentValue === '') {
					setReportCheckError('notes');
					return;
				}

				if (!selectedReportCheckReasons.length) {
					setReportCheckError('reasons');
					return;
				}

				if (reportCheckCommentValue && !!selectedReportCheckReasons.length) {
					dispatch(
						actionClientRequestReport(
							{
								reportId: {
									id: report && report.reportId.id,
								},
								reviewReasons: selectedReportCheckReasons.map((value: any) => {
									return {
										id: parseFloat(value),
									};
								}),
								notes: reportCheckCommentValue,
								checkType: selectedCheckTypeOption,
								claimType:
									selectedActionOption === 'formClaim'
										? 'Claim'
										: 'Recommendation',
							},
							selectedFiles,
							'reportCheckBtn'
						)
					);
				}
			}
		}
		if (actualPurpose === 'deleteUsersClaims') {
			console.log(selectedUserId);
		}
		if (unloadActions.hasOwnProperty(actualPurpose)) {
			if (reportLimit === '') {
				setError('Вы должны указать значение лимита выгрузки');
				return;
			} else {
				const action = unloadActions[actualPurpose];

				if (actualPurpose === 'unloadExpiredList') {
					dispatch(action(parseFloat(reportLimit)));
				} else if (actualPurpose === 'unloadReportsPhotos') {
					dispatch(
						action({
							customServices: selectedCustomServices,
							actions: selectedActions,
							reportFilter: {
								...reportsInputValues,
								limit: parseFloat(reportLimit),
								page: 1,
							},
						})
					);
				} else {
					dispatch(
						action({
							...reportsInputValues,
							limit: parseFloat(reportLimit),
							page: 1,
						})
					);
				}

				setError('');
			}
		}
		if (actualPurpose === 'lostVacancyRoutes') {
			dispatch(reducerSingleVacancyIV({
				...inputValues,
				editType: false
			}));
			setOpen(false);
		}
		if (actualPurpose === 'createReports') {
			selectedFiles.length &&
				dispatch(actionImportReport(selectedFiles)).then(() => {
					setSelectedFiles([]);
				});
		}
		if (actualPurpose === 'uploadKPI') {
			selectedFiles.length &&
				dispatch(actionImportReportKPI(selectedFiles)).then(() => {
					setSelectedFiles([]);
				});
		}
		document.body.style.overflow = 'auto';
		setOpen(false);
	};

	const handleClickOpenBtn = (purpose: any, modalTitle: any) => {
		console.log(purpose);
		const openActions: any = {
			navigateToVacancyList: () => {
				if (!editForm) {
					dispatch(reducerHeaderBtn({ purpose, title: modalTitle }));
					const urlParams = new URLSearchParams(window.location.search);
					const source = urlParams.get('source');
					navigate(source || '/recruiting/vacancy');
				} else {
					dispatch(reducerHeaderBtn({ purpose, title: modalTitle, open: !open }));
					setOpen(!open);
				}
			},
			createVacancyVacant: () => {
				if (CheckBeforeCreate(vacantCheckboxes) === 'empty') {
					dispatch(reducerHeaderBtn({ purpose, title: modalTitle, open: !open }));
					setOpen(true);
				}
			},
			createVacancyVacantRoutes: () => {
				if (CheckBeforeCreate(vacantCheckboxes) === 'empty') {
					dispatch(reducerHeaderBtn({ purpose, title: modalTitle, open: !open }));
					setOpen(!open);
				} else {
					setDisabledButton(true);
					dispatch(actionCreateVacancy(dataForCreate(vacantCheckboxes), '4', navigate)).then(() => {
						setDisabledButton(false);
					})
				}
			},
			createVacancyRoutes: () => {
				if (CheckBeforeCreate(vacantCBnew) === 'empty') {
					dispatch(reducerHeaderBtn({ purpose, title: modalTitle, open: !open }));
					setOpen(!open);
				} else {
					setDisabledButton(true);
					dispatch(actionCreateVacancy(dataForCreate(vacantCBnew), '5', navigate)).then(() => {
						setDisabledButton(false);
					})
					dispatch(reducerUpdatedData(true));
				}
			},
			createExpiredReports: () => {
				dispatch(actionCreateExpiredReports(reportsId));
			},
			visitSchedule: () => {
				return;
			},
			showVisitScheduleHistory: () => {
				dispatch(reducerVisitScheduleHistory(!isOpenHistory));
			},
			unloadScheduleExcel: () => {
				dispatch(actionUnloadScheduleInExcel());
			},
			sendRoutesToEasyMerch: () => {
				dispatch(actionSendRoutesToEasyMerch(0, selectedUsers));
			},
			addRouteOnVacancy: () => {
				dispatch(reducerSingleVacancyStatus(null));
				dispatch(reducerSingleVacancyStatusMessage(null));
				dispatch(reducerHeaderBtn({ purpose, title: modalTitle, open: !open }));
				dispatch(reducerVacantRoutesInputValues({
					canBeAttachedToVacancy: true,
					project: inputValues.projects
				}));
				setOpen(!open);
			},
			defaultAction: () => {
				dispatch(reducerHeaderBtn({ purpose, title: modalTitle, open: !open }));
				setOpen(!open);
			},
		};
		const action = openActions[purpose] || openActions.defaultAction;
		action();
	};

	const handleClickCloseBtn = () => {
		const action = closeActions[actualPurpose];
		if (actualPurpose === 'createVacancyRoutes' || actualPurpose === 'createVacancyVacantRoutes') {
			const undInputValues = { ...vacancyCreateInputValues, type: 'NO_ROUTE' };
			delete undInputValues.routesNo;
			delete undInputValues.project;
			dispatch(reducerCreateVacancyInputValues(undInputValues));
			dispatch(reducerHandleErrors(null));
			dispatch(reducerVacancyStatus(null));
			dispatch(reducerRoutesStatus(null));
			dispatch(reducerVacantRoutesStatus(null));
		}
		if (actualPurpose === 'createVacancyVacant') {
			const undInputValues = { ...vacancyCreateInputValues, type: 'NO_ROUTE' };
			delete undInputValues.routesNo;
			delete undInputValues.projects;
			delete undInputValues.projectRoutes;
			dispatch(reducerCreateVacancyInputValues(undInputValues));
			dispatch(reducerHandleErrors(null));
			dispatch(reducerVacancyStatus(null));
			dispatch(reducerRoutesStatus(null));
			dispatch(reducerVacantRoutesStatus(null));
		}
		if (actualPurpose === 'lostVacancyRoutes') {
			dispatch(reducerSingleVacancyIV({
				...inputValues,
				type: Object.keys(singleVacancyData.type.value)[0],
				editType: false
			}));
			setOpen(false);
		}
		if (actualPurpose === 'addRouteOnVacancy') {
			dispatch(reducerVacantRoutesInputValues({ project: null }))
		}
		if (actualPurpose === 'vacantRoutesSettings') {
			setSelectedVacantRoutesSettings(vacantRoutesSettings);
		}
		if (actualPurpose === 'vacancyListSettings') {
			setSelectedVacancyListSettings(vacancyListSettings);
		}
		if (actualPurpose === 'routesSettings') {
			setSelectedRoutesSettings(routesSettings);
		}
		if (actualPurpose === 'adminReportsSettings') {
			setSelectedReportsSettings(adminReportsSettings);
		}
		if (action) {
			action();
		}
		document.body.style.overflow = 'auto';
		setSelectedFiles([]);
		setOpen(false);
		setError('');
	};

	const handleChangeLimitInput = (event: any) => {
		setReportLimit(event.target.value);
		setError('');
	};

	const handleFileChange = (event: any) => {
		const files = event.target.files;
		setSelectedFiles([...selectedFiles, ...files]);
	};

	const generateLimitSection = () => (
		<LimitSection
			handleChangeLimitInput={handleChangeLimitInput}
			error={error}
		/>
	);
	const sectionComponents: any = {
		addressInfo: <ScheduleAddressInfoSection content={content} />,
		unloadReportsConsolidated: generateLimitSection(),
		unloadCustomerReportsData: generateLimitSection(),
		unloadReportsWithLinks: generateLimitSection(),
		unloadCustomerReports: generateLimitSection(),
		unloadClientReport: generateLimitSection(),
		unloadReportsList: generateLimitSection(),
		unloadExpiredList: generateLimitSection(),
		averageFacing: generateLimitSection(),
		unloadHotline: generateLimitSection(),
		shelfShare: generateLimitSection(),
		deletePhotos: <DeletePhotosSection />,
		createGeo: <CreateGeoSection />,
		osa: generateLimitSection(),
		addRouteOnVacancy: <AddRouteOnVacancySection />,
		deleteExpired: (
			<DeleteReportSection title='Вы уверены, что хотите удалить выбранные отчеты ?' />
		),
		navigateToVacancyList: (
			<NavigateToSection title='Вернуться к списку вакансий без сохранения изменений ?' />
		),
		navigateToProjectsList: (
			<NavigateToSection title='Вернуться к списку проектов без сохранения изменений ?' />
		),
		navigateToApplicationsList: (
			<NavigateToSection title='Вернуться к списку анкет без сохранения изменений ?' />
		),
		deleteReport: (
			<DeleteReportSection title='Вы уверены, что хотите удалить отчет ?' />
		),
		removeSelections: <DeleteRouteSection title='Снять выделения ?' />,
		deleteRoute: <DeleteRouteSection title='Удалить маршрут с вакансии ?' />,
		vacancyUpdate: <VacancyUpdateSection title={'Сохранить изменения ?'} />,
		createVacancy: <CreateVacancy title='Создать вакансию ?' />,
		newApplication: <NewApplication title='Создать анкету ?' />,
		newUsersClaims: <NewUsersClaims />,
		createVacancyVacant: <VacancyCreateNewSection title='Создать вакансию ?' />,
		createVacancyVacantRoutes: <VacancyCreateNewSection title='Создать вакансию ?' />,
		createVacancyRoutes: <VacancyCreateNewSection title='Создать вакансию ?' />,
		lostVacancyRoutes: <LostVacancyRoutestSection title='При сохранении данного типа вакансии будет потеряна связь со всеми маршрутами. Сменить тип маршрута ?' />,
		reportCheck: (
			<ReportCheckSection
				setSelectedReportCheckReasons={setSelectedReportCheckReasons}
				selectedReportCheckReasons={selectedReportCheckReasons}
				setSelectedCheckTypeOption={setSelectedCheckTypeOption}
				setReportCheckCommentValue={setReportCheckCommentValue}
				setSelectedActionOption={setSelectedActionOption}
				selectedActionOption={selectedActionOption}
				handleFileChange={handleFileChange}
				setSelectedFiles={setSelectedFiles}
				setIsError={setReportCheckError}
				selectedFiles={selectedFiles}
				isError={reportCheckError}
			/>
		),
		updateReviewStatus: (
			<UpdateReviewStatusSection
				setSelectedOption={setSelectedReviewStatusOption}
				setSelectedReason={setSelectedReviewReasonId}
				setReviewReasonError={setReviewReasonError}
				reviewReasonError={reviewReasonError}
			/>
		),
		unloadReportsPhotos: (
			<UnloadReportsPhotoSection
				setSelectedCustomServices={setSelectedCustomServices}
				handleChangeLimitInput={handleChangeLimitInput}
				setSelectedActions={setSelectedActions}
				error={error}
			/>
		),
		customerReportsSettings: (
			<CustomerReportsSettingsSection
				setSelectedReportsSettings={setSelectedReportsSettings}
				selectedReportsSettings={selectedReportsSettings}
				setIsCheckedFullInfo={setIsCheckedAllSettings}
				isCheckedFullInfo={isCheckedAllSettings}
			/>
		),
		adminReportsSettings: (
			<AdminReportsSettingsSection
				setSelectedReportsSettings={setSelectedReportsSettings}
				selectedReportsSettings={selectedReportsSettings}
				setIsCheckedFullInfo={setIsCheckedAllSettings}
				isCheckedFullInfo={isCheckedAllSettings}
			/>
		),
		expiredReportsSettings: (
			<ExpiredReportsSettingsSection
				setSelectedReportsSettings={setSelectedExpiredReportsSettings}
				selectedReportsSettings={selectedExpiredReportsSettings}
				setIsCheckedFullInfo={setIsCheckedAllExpiredSettings}
				isCheckedFullInfo={isCheckedAllExpiredSettings}
			/>
		),
		routesSettings: (
			<RoutesSettingsSection
				setSelectedRoutesSettings={setSelectedRoutesSettings}
				selectedRoutesSettings={selectedRoutesSettings}
				setIsCheckedFullInfo={setIsCheckedAllRoutesSettings}
				isCheckedFullInfo={isCheckedAllRoutesSettings}
			/>
		),
		vacantRoutesSettings: (
			<VacantRoutesSettingsSection
				setSelectedVacantRoutesSettings={setSelectedVacantRoutesSettings}
				selectedVacantRoutesSettings={selectedVacantRoutesSettings}
				setIsCheckedFullInfo={setIsCheckedAllVacantRoutesSettings}
				isCheckedFullInfo={isCheckedAllVacantRoutesSettings}
			/>
		),
		vacancyListSettings: (
			<VacancyListSettingsSection
				setSelectedVacancyListSettings={setSelectedVacancyListSettings}
				selectedVacancyListSettings={selectedVacancyListSettings}
				setIsCheckedFullInfo={setIsCheckedAllVacancyListSettings}
				isCheckedFullInfo={isCheckedAllVacancyListSettings}
			/>
		),
		singleReportSettings: (
			<SingleReportSettingsSection
				setReorderedReportOptions={setReorderedReportOptions}
				setSelectedReportTabs={setSelectedReportTabs}
				setIsCheckedFullInfo={setIsCheckedFullInfo}
				selectedReportTabs={selectedReportTabs}
				isCheckedFullInfo={isCheckedFullInfo}
			/>
		),
		adminSingleReportSettings: (
			<AdminSingleReportSettingsSection
				setReorderedReportOptions={setReorderedReportOptions}
				setSelectedReportTabs={setSelectedReportTabs}
				setIsCheckedFullInfo={setIsCheckedFullInfo}
				selectedReportTabs={selectedReportTabs}
				isCheckedFullInfo={isCheckedFullInfo}
			/>
		),
		createReports: (
			<OutletsDownloadSection
				handleFileChange={handleFileChange}
				setSelectedFiles={setSelectedFiles}
				selectedFiles={selectedFiles}
			/>
		),
		uploadKPI: (
			<OutletsDownloadSection
				handleFileChange={handleFileChange}
				setSelectedFiles={setSelectedFiles}
				selectedFiles={selectedFiles}
			/>
		),

		outletsDownload: (
			<OutletsDownloadSection
				handleFileChange={handleFileChange}
				setSelectedFiles={setSelectedFiles}
				selectedFiles={selectedFiles}
			/>
		),
		copyReport: (
			<CopyReportSection
				setSelectedDate={setSelectedDate}
				selectedDate={selectedDate}
			/>
		),
		copyReports: (
			<CopyReportSection
				setSelectedDate={setSelectedDate}
				selectedDate={selectedDate}
			/>
		),

		updateDeliveryStatus: (
			<UpdateDeliveryStatusSection
				setSelectedOption={setSelectedDeliveryOption}
			/>
		),
		updateRateStatus: (
			<UpdateRateStatusSection
				setSelectedOption={setSelectedRateStatusOption}
			/>
		),
	};

	useEffect(() => {
		setOpen(inputValues.editType);
	}, [inputValues.editType]);

	return (
		<div className={styles.wrapper}>
			<div
				className={
					isOpenHistory && purpose === 'showVisitScheduleHistory'
						? styles.active__header_btn
						: purpose === 'addressInfo'
							? styles.address__link
							: styles.header__btn
				}
				onClick={() => {
					!disabledButton && handleClickOpenBtn(purpose, modalTitle);
				}}
			>
				<span className={styles.header__btn_content}>{content}</span>
			</div>
			{open && (
				<Blackout onClose={handleClickCloseBtn}>
					<div
						className={
							purpose === 'unloadReportsPhotos' || purpose === 'addressInfo'
								? styles.long__modal
								:  purpose === 'createVacancyVacantRoutes'
									? styles.tall__modal
									: (purpose === 'newApplication' || purpose === 'newUsersClaims')
										? styles.modal__application
										: styles.modal
						}
						id='headerBtnModal'
						onClick={(event: any) => event.stopPropagation()}
					>
						<div className={styles.modal__title_block}>
							<span>{actualModalTitle}</span>
							<img
								style={{ cursor: 'pointer' }}
								onClick={handleClickCloseBtn}
								src={Close}
								alt='close'
							/>
						</div>
						{actualPurpose !== 'outletsUnload' &&
							actualPurpose !== 'errorsUnload' && (
								<div
									className={
										actualPurpose === 'reportCheck'
											? styles.reportCheck__content_block
											: actualPurpose.includes('Settings')
												? styles.settings__content_block
												: actualPurpose === 'createVacancyVacant' || actualPurpose === 'createVacancyRoutes' || actualPurpose === 'createVacancyVacantRoutes'
													? styles.vacancy__content_block
													: styles.content__block
									}
								>
									{sectionComponents[actualPurpose]}
								</div>
							)}
						<div className={styles.btn__block}>
							{actualPurpose !== 'addressInfo' && (
								<button
									className={styles.accept__btn}
									disabled={disabledButton}
									onClick={handleClickApplyBtn}
								>
									Применить
								</button>
							)}
							<button
								className={styles.cancel__btn}
								onClick={handleClickCloseBtn}
							>
								Отмена
							</button>
						</div>
					</div>
				</Blackout>
			)}
		</div>
	);
};

export default HeaderBtn;
